import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const res = await axios.post('/api/auth/unified-login', { username, password });
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('user', JSON.stringify(res.data.user));
      const role = res.data.user.role;
      navigate(role === 'admin' ? '/admin' : '/teacher');
    } catch (err) {
      setError(err.response?.data?.message || 'Anmeldung fehlgeschlagen');
    }
  };

  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', minHeight: 'calc(100vh - 57px)' }}>

      {/* Left — editorial panel */}
      <div style={{
        background: 'var(--bg-deeper)',
        padding: '60px',
        display: 'flex', flexDirection: 'column', justifyContent: 'space-between',
        borderRight: '1px solid var(--line)',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{ width: 28, height: 28, borderRadius: 8, background: 'var(--grad)', flexShrink: 0 }} />
          <span className="display" style={{ fontSize: 17 }}>Wochenplaner</span>
        </div>

        <div>
          <div className="mono" style={{
            fontSize: 11, color: 'var(--ink-3)',
            letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 14,
          }}>
            Schulaufgabenverwaltung
          </div>
          <h1 className="display" style={{ fontSize: 48, margin: 0, lineHeight: 1.05 }}>
            Die Woche.<br />
            <span style={{ color: 'var(--ink-3)' }}>Auf einen Blick.</span>
          </h1>
          <p style={{ fontSize: 15, color: 'var(--ink-2)', maxWidth: 380, marginTop: 18, lineHeight: 1.6 }}>
            Lektionen, Hausaufgaben und Fortschritt —<br />alles an einem Ort.
          </p>
        </div>

        <div className="mono" style={{ fontSize: 10, color: 'var(--ink-4)', letterSpacing: '0.06em' }}>
          v2.0 · 2026
        </div>
      </div>

      {/* Right — login card */}
      <div style={{
        background: 'var(--paper)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 60,
      }}>
        <div style={{ width: '100%', maxWidth: 360 }}>
          <h2 className="display" style={{ fontSize: 26, margin: '0 0 6px' }}>Anmelden</h2>
          <p style={{ fontSize: 14, color: 'var(--ink-3)', margin: '0 0 28px' }}>
            Mit deinem Schul-Login.
          </p>

          <form onSubmit={handleSubmit}>
            <label style={{ fontSize: 12, fontWeight: 600, color: 'var(--ink-2)', display: 'block', marginBottom: 6 }}>
              Benutzername
            </label>
            <input
              className="input"
              type="text"
              value={username}
              onChange={e => setUsername(e.target.value)}
              placeholder="Benutzername eingeben"
              autoFocus
              required
              style={{ marginBottom: 14 }}
            />

            <label style={{ fontSize: 12, fontWeight: 600, color: 'var(--ink-2)', display: 'block', marginBottom: 6 }}>
              Passwort
            </label>
            <input
              className="input"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="Passwort eingeben"
              required
              style={{ marginBottom: error ? 10 : 22 }}
            />

            {error && (
              <p style={{ fontSize: 13, color: 'var(--danger)', margin: '0 0 14px' }}>{error}</p>
            )}

            <button type="submit" className="btn btn-grad" style={{ width: '100%', padding: '11px 14px', fontSize: 14 }}>
              Anmelden
            </button>
          </form>
        </div>
      </div>

    </div>
  );
}

export default Login;
